class KML {
  constructor(url) {
    this.url = url;
  }
}

export class KMLLoader {
  static async load(url) {
    let kml = new KML(url);
    return kml;
  }
}